import create from 'zustand'
import immer from './immer'
import { devtools } from "zustand/middleware"
let useSectionStore = (set) => ({
    sections: [],
    tempRow: {},
    branch: {},
    sem: 1,
    setSem: (sem) => set(state => void (state.sem = sem)),
    loading: true,
    setSectionsLoading: () => set(state => void (state.loading = true)),
    addtempRow: (row) => {
        set(state => void (state.tempRow = row))
    },
    addSection: (section) => set((state) => {
        const ind = state.sections.filter((ele, index) => {
            if (ele._id == section._id) {
                state.sections[index] = section;
                return true;
            }
        });
        if (!ind || ind.length < 1) {
            state.sections.push(section);
        }
    }),
    removeSection: (secId) => set((state) => {
        state.sections = state.sections.filter((sec => sec._id !== secId));
    }),
    initSections: (secs, currentBranch) => set((state) => {
        state.sections = secs;
        state.branch = currentBranch;
        state.loading = false;
    }),
    updateEoa: (eoa) => set((state) => void (state.branch.eoa = eoa))
})
useSectionStore = devtools(useSectionStore, { name: "sections" });
useSectionStore = immer(useSectionStore);
export default create(useSectionStore);